import { Product } from "../types/product";
import { useQuery } from "react-query";
import { getProductType } from "components/HomeRepairFunnelV2/utils";

interface BonusResponse {
  amount: number;
  error: string;
}

const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

function Query(product: Product) {
  return useQuery<BonusResponse>(
    /* 1 day cache on this call */
    // TODO: remove the product_type parsing for fridge once the types used in frontend and backend are coherent
    [
      "payment/paymentbilling/repair-bonus-amount",
      {
        product_type: getProductType(product),
        brand: product.brand,
      },
    ],
    {
      cacheTime: ONE_DAY_IN_MILLISECONDS,
      staleTime: ONE_DAY_IN_MILLISECONDS,
    }
  );
}

export default function useRepairBonusAmount(products: Product[]): number {
  /**
   * Gets the repair bonus amounts of all products in card (maximum of 3)
   * returns the total amount of repair bonus
   */
  let amount_first_product = 0;
  let amount_second_product = 0;
  let amount_third_product = 0;

  const { data: data_1, isSuccess: success_1 } =
    products.length > 0 ? Query(products[0]) : { isSuccess: false, data: { amount: 0 } };
  const { data: data_2, isSuccess: success_2 } =
    products.length > 1 ? Query(products[1]) : { isSuccess: false, data: { amount: 0 } };
  const { data: data_3, isSuccess: success_3 } =
    products.length > 2 ? Query(products[2]) : { isSuccess: false, data: { amount: 0 } };

  if (success_1 && data_1) amount_first_product = data_1.amount;
  if (success_2 && data_2) amount_second_product = data_2.amount;
  if (success_3 && data_3) amount_third_product = data_3.amount;

  return amount_first_product + amount_second_product + amount_third_product;
}
